import { ResourcesTab } from '../../components/organisms/navigation/ResourcesTab'
import useUserPermission from '../useUserPermission'

const useBranchOfficeRoute = () => {
  const { canSeeBranchOffices } = useUserPermission('menu')

  return [{ path: '/sedes', component: ResourcesTab, hasPermission: canSeeBranchOffices }]
}
export default useBranchOfficeRoute
